import categories from './categories';
import providers from './providers';
import products from './products';
import presents from './presents';
import coupons from './coupons';
import orders from './orders';
import chance from '../chance';

export default [chance, categories, providers, products, coupons, presents, orders];
